import type { WRMType } from './requireLegacyWRM.ts';
import {
	isSuperbatchRecoveryEnabled,
	SUPERBATCH_RECOVERY_TIMEOUT_MS,
} from './superbatchRecovery.ts';

let wrm: Promise<WRMType> | null = null;
export function waitForWRM(signal?: AbortSignal): Promise<WRMType> {
	if (wrm) {
		return wrm;
	}
	if (isSuperbatchRecoveryEnabled()) {
		wrm = new Promise((resolve, reject) => {
			if (signal?.aborted) {
				reject(new Error('Superbatch loading timed out'));
				return;
			}
			let timeout: number | undefined;
			const cleanup = () => {
				window.clearInterval(interval);
				window.clearTimeout(timeout);
				signal?.removeEventListener('abort', onAbort);
			};
			const onAbort = () => {
				cleanup();
				reject(new Error('Superbatch loading timed out'));
			};
			const interval = window.setInterval(() => {
				if (window.WRM && typeof window.WRM.require === 'function') {
					cleanup();
					resolve(window.WRM);
				}
			}, 50);
			if (signal) {
				// The recovery wrapper owns the deadline for the entire loading pipeline.
				signal.addEventListener('abort', onAbort, { once: true });
			} else {
				timeout = window.setTimeout(() => {
					cleanup();
					reject(new Error('WRM bootstrap timed out'));
				}, SUPERBATCH_RECOVERY_TIMEOUT_MS);
			}
		});
		return wrm;
	}

	wrm = new Promise((resolve) => {
		const wrmInterval = window.setInterval(() => {
			if (window.WRM && typeof window.WRM.require === 'function') {
				window.clearInterval(wrmInterval);
				resolve(window.WRM);
			}
		}, 50);
	});

	return wrm;
}
